module.exports = __webpack_public_path__ + "static/media/apex-logo-reverse.e9c20128.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CenteredAppHeader/apex-logo-reverse.svg
// module id = 2433
// module chunks = 0